(function () {

    "use strict";

    function headListController() {

    }

    headListController.$inject = [];

    angular.module("sphforms.main")
        .component("sphFormsHeadList", {
            controller: headListController,
            bindings: {
                idEntity: "<",
                entity: "=",
                icon: "<",
                service: "="
            },
            templateUrl: "modules/main/components/ui/basicList/headList/headList.template.html"
        });

}());